import React, { useState, useEffect } from "react";
import { getIcons } from "../../Constant/Constant";
import propertyService from "../../Services/PropertyService";

const EstimateHistoryModel = ({ isOpen, onClose }) => {
  const [estimates, setEstimates] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedEstimate, setSelectedEstimate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentDate, setCurrentDate] = useState("");

  console.log(currentDate)
  const icon = getIcons();


  useEffect(() => {
    const today = new Date(); 
    const formattedDate = today.toISOString().split('T')[0]; 
    setCurrentDate(formattedDate); 
  }, [isOpen]);

  useEffect(() => {
  
    if (isOpen) {
      const getEstimate = async () => {
        try {
          const response = await propertyService.getAllEstimatesHistories(
            currentDate
          );
          setEstimates(response.data || []);
          
          console.log(response.data);
        } catch (e) {
          console.error("Error fetching estimates:", e);
        }
      };

      getEstimate();
    }
  }, [isOpen,currentDate]);



  if (!isOpen) {
    return null;
  }

  const handleViewClick = async (estimateId) => {
    try {
      const response = await propertyService.getEstimateById(estimateId);
      setSelectedEstimate(response.data);
      setShowPreview(true);
    } catch (e) {
      console.error("Error fetching estimate:", e);
    }
  };

  const handleClosePreview = () => {
    setShowPreview(false);
    setSelectedEstimate(null);
  };

  const filteredEstimates = estimates.filter((estimate) =>
    estimate.leadName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getLocalDate = () => {
    return new Date().toISOString().split("T")[0];
  };



  const handelClose = ()=>{
    onClose();
    setSelectedEstimate(null);
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className={`bg-white p-5 rounded-lg shadow-lg ${showPreview ? "w-[860px]" : "w-[560px]" }  h-[604px] mt-[70px]`}>
        {!showPreview ? (
          <div className="flex justify-between items-center">
            <h2 className="text-[24px] font-semibold text-customGreen">
              Estimate History
            </h2>
            <div className="flex items-center border-2 border-slate-300 rounded-md px-3 py-2 shadow-sm focus-within:border-blue-500">
              <span className="  font-medium  text-gray-600">Date:</span>
              <input
                type="date"
                onChange={
                  (e) =>{
                    setCurrentDate(e.target.value);
                  }
                }
                value={currentDate}
                className="form-control outline-none bg-transparent ml-2 text-gray-700"
              max={getLocalDate()}
              />
            </div>

            <button className="text-gray-500" onClick={handelClose}>
              ✖
            </button>
          </div>
        ) : (
          <div className="flex justify-between items-center">
            <h2 className="text-[24px] font-semibold text-customGreen">
              Estimate Preview
            </h2>
            <button className="text-gray-500" onClick={handleClosePreview}>
              ✖
            </button>
          </div>
        )}
        {!showPreview ? (
          <div>
            <p className="text-[18px] font-medium mt-5 text-gray-600">
              Total Estimate of the day: {filteredEstimates.length}
            </p>
            <div className="relative mt-2">
              {icon?.searchIcon && (
                <img
                  src={icon.searchIcon}
                  alt="Search"
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
                />
              )}
              <input
                type="text"
                placeholder="Type Lead Name"
                className="w-full border p-2 pl-10 rounded-lg"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="mt-3 space-y-2 overflow-y-auto max-h-96 custom-scrollbar">
              {filteredEstimates.length > 0 ? (
                filteredEstimates.map((estimate) => (
                  <div
                    key={estimate.id}
                    className="flex justify-between items-center border-2 border-gray-200 py-3 p-2 rounded-md"
                  >
                    <div className="flex flex-col gap-2">
                      <p className="text-sm font-semibold">
                        Estimate ID: {estimate?.estimateId}
                      </p>
                      <p className="text-sm">
                        Lead Name: {estimate?.leadName || ""}
                      </p>
                      <p className="text-sm">
                        User Name: {estimate?.userName || ""}
                      </p>
                    </div>

                    <button
                      className="text-blue-500"
                      onClick={() => handleViewClick(estimate?.id)}
                    >
                      View
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500 mt-3">
                  No estimates found
                </p>
              )}
            </div>
          </div>
        ) : (
          <div className=" overflow-y-auto  max-h-[500px] custom-scrollbar">
            {/* <div className="bg-white w-full border p-4 rounded-lg">
              <div>
                <img src={headerImage} alt="Header" />
              </div>

              <div className="p-4">
                <div className="flex justify-between items-center">
                  <h1 className="text-xl font-bold text-[#2E6D92]">
                    Property Estimate
                  </h1>
                  <p className="text-sm">
                    Estimate ID: {selectedEstimate?.estimateId || "EST001"}
                  </p>
                </div>

                <div className="flex justify-between mt-4">
                  <div>
                    <h2 className="text-base text-start font-bold">
                      {selectedEstimate?.propertyName || "Unknown"}
                    </h2>
                    <p className="text-sm">
                      Plot No {selectedEstimate?.plotNo || "N/A"},{" "}
                      {selectedEstimate?.totalPlotSqft || "0"} SQ Feet
                    </p>
                  </div>
                  <div className="text-right text-sm">
                    <p>Created On: {currentDate}</p>
                    <p>
                      Created By:{" "}
                      {selectedEstimate?.createdByEmployeeId || "Unknown"}
                    </p>
                  </div>
                </div>

                <div className="mt-3 text-start text-sm">
                  <p>
                    Per Sq feet Price: ₹
                    {selectedEstimate?.plotPerSqftPrice?.toLocaleString(
                      "en-IN"
                    ) || "0"}
                  </p>
                  <p>
                    Per Sq feet Guideline Value: ₹
                    {selectedEstimate?.guidelineValue?.toLocaleString(
                      "en-IN"
                    ) || "0"}
                  </p>
                </div>

                <div className="mt-4">
                  <table className="w-full border-collapse border border-gray-800 text-sm">
                    <tbody>
                      <tr>
                        <td
                          colSpan="2"
                          className="border border-gray-800 p-2 text-center font-bold"
                        >
                          Price Detail
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 p-2 pl-4">
                          <div>Actual Price</div>
                          <div>
                            ({selectedEstimate?.totalPlotSqft || "0"} x{" "}
                            {selectedEstimate?.plotPerSqftPrice || "0"})
                          </div>
                        </td>
                        <td className="border border-gray-800 p-2 text-right pr-4">
                          ₹
                          {selectedEstimate?.actualAmount?.toLocaleString(
                            "en-IN"
                          ) || "0"}
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 p-2 pl-4">
                          <div>Registration cost</div>
                          <div>
                            ({selectedEstimate?.totalPlotSqft || "0"} x{" "}
                            {selectedEstimate?.guidelineValue || "0"} x 9%)
                          </div>
                        </td>
                        <td className="border border-gray-800 p-2 text-right pr-4">
                          ₹
                          {selectedEstimate?.registrationCharge?.toLocaleString(
                            "en-IN"
                          ) || "0"}
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 p-2 pl-4">
                          Document Charge
                        </td>
                        <td className="border border-gray-800 p-2 text-right pr-4">
                          ₹
                          {selectedEstimate?.documentCharge?.toLocaleString(
                            "en-IN"
                          ) || "0"}
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-800 p-2 pl-4 font-bold">
                          Total Price
                        </td>
                        <td className="border border-gray-800 p-2 text-right pr-4 font-bold">
                          ₹
                          {selectedEstimate?.totalAmount?.toLocaleString(
                            "en-IN"
                          ) || "0"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {selectedEstimate?.loanPercentage > 0 && (
                  <div className="mt-4">
                    <table className="w-full border-collapse border border-gray-800 text-sm">
                      <tbody>
                        <tr>
                          <td
                            colSpan="2"
                            className="border border-gray-800 p-2 text-center font-bold"
                          >
                            Loan Details
                          </td>
                        </tr>
                        <tr>
                          <td className="border border-gray-800 p-2 pl-4">
                            <div>
                              Loan {selectedEstimate?.loanPercentage || "0"}%
                            </div>
                            <div>
                              ({selectedEstimate?.totalPlotSqft || "0"} x{" "}
                              {selectedEstimate?.plotPerSqftPrice || "0"} x{" "}
                              {selectedEstimate?.loanPercentage || "0"}%)
                            </div>
                          </td>
                          <td className="border border-gray-800 p-2 text-right pr-4">
                            ₹
                            {selectedEstimate?.loanAmount?.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </td>
                        </tr>
                        <tr>
                          <td className="border border-gray-800 p-2 pl-4 font-bold">
                            Down Payment
                          </td>
                          <td className="border border-gray-800 p-2 text-right pr-4 font-bold">
                            ₹
                            {selectedEstimate?.downPayment?.toLocaleString(
                              "en-IN"
                            ) || "0"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="flex justify-between mt-4 items-end">
                  <div className="text-sm">
                    Estimate Valid Till -{" "}
                    {formatDate(selectedEstimate?.expiryTimestamp)}
                  </div>
                  <div>
                    {approveImage && (
                      <img src={approveImage} alt="Approved" className="h-20" />
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <img src={footerImage} alt="Footer" />
              </div>
            </div> */}

              <div dangerouslySetInnerHTML={{ __html: selectedEstimate }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default EstimateHistoryModel;
